import { observable, action, decorate } from 'mobx'
import { setErrorsOnFormAndNotifyGeneralErrors } from '../helpers/generalHelpers'
import { category as categoryApi } from '../api/services/category'

class categoryStore {
  isLoading = false

  categories = []

  fetchCategories = (list) => {
    this.categories = list
  }
  setIsLoading = (bool) => {
    this.isLoading = bool
  }
}
decorate(categoryStore, {
  isLoading: observable,
  categories: observable,
  fetchCategories: action,
  setIsLoading: action,
})
const CategoryList = new categoryStore()

export async function fetchCategoriesList(params) {
  CategoryList.setIsLoading(true)
  const [err, res] = await categoryApi.getAll(params)
  if (res && !err) {
    CategoryList.fetchCategories(res.categories)
    CategoryList.setIsLoading(false)
    return res.categories
  }

  CategoryList.setIsLoading(false)
  setErrorsOnFormAndNotifyGeneralErrors(err)
  return err
}
export default CategoryList
